
    import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
    @Component
    export default class SearchOrderNum extends Vue {
      private orderNum: string = ''
      @Emit('getOrderNum')
       sendOrderNum(orderNum:string){}
    }
